Object.defineProperty(exports, "__esModule", {
    value: true
});
var _sliced_to_array = require("@swc/helpers/_/_sliced_to_array");
//#region src/updateOptions.ts
function updateConsumeOptions(options) {
    var webpackRequire = options.webpackRequire, moduleToHandlerMapping = options.moduleToHandlerMapping;
    var consumesLoadingData = webpackRequire.consumesLoadingData, initializeSharingData = webpackRequire.initializeSharingData;
    var _webpackRequire_federation = webpackRequire.federation, sharedFallback = _webpackRequire_federation.sharedFallback, bundlerRuntime = _webpackRequire_federation.bundlerRuntime, libraryType = _webpackRequire_federation.libraryType;
    if (consumesLoadingData && !consumesLoadingData._updated) {
        var tmp = consumesLoadingData.moduleIdToConsumeDataMapping, updatedModuleIdToConsumeDataMapping = tmp === void 0 ? {} : tmp, tmp1 = consumesLoadingData.initialConsumes, updatedInitialConsumes = tmp1 === void 0 ? [] : tmp1, tmp2 = consumesLoadingData.chunkMapping, updatedChunkMapping = tmp2 === void 0 ? {} : tmp2;
        Object.entries(updatedModuleIdToConsumeDataMapping).forEach((param)=>{
            var _param = _sliced_to_array._(param, 2), id = _param[0], data = _param[1];
            if (!moduleToHandlerMapping[id]) moduleToHandlerMapping[id] = {
                getter: sharedFallback ? bundlerRuntime === null || bundlerRuntime === void 0 ? void 0 : bundlerRuntime.getSharedFallbackGetter({
                    shareKey: data.shareKey,
                    factory: data.fallback,
                    webpackRequire,
                    libraryType
                }) : data.fallback,
                treeShakingGetter: sharedFallback ? data.fallback : void 0,
                shareInfo: {
                    shareConfig: {
                        requiredVersion: data.requiredVersion,
                        strictVersion: data.strictVersion,
                        singleton: data.singleton,
                        eager: data.eager,
                        layer: data.layer
                    },
                    scope: Array.isArray(data.shareScope) ? data.shareScope : [
                        data.shareScope || "default"
                    ],
                    treeShaking: sharedFallback ? {
                        get: data.fallback,
                        mode: data.treeShakingMode
                    } : void 0
                },
                shareKey: data.shareKey
            };
        });
        if ("initialConsumes" in options) {
            var _options_initialConsumes = options.initialConsumes, initialConsumes = _options_initialConsumes === void 0 ? [] : _options_initialConsumes;
            updatedInitialConsumes.forEach((id)=>{
                if (!initialConsumes.includes(id)) initialConsumes.push(id);
            });
        }
        if ("chunkMapping" in options) {
            var _options_chunkMapping = options.chunkMapping, chunkMapping = _options_chunkMapping === void 0 ? {} : _options_chunkMapping;
            Object.entries(updatedChunkMapping).forEach((param)=>{
                var _param = _sliced_to_array._(param, 2), id = _param[0], chunkModules = _param[1];
                if (!chunkMapping[id]) chunkMapping[id] = [];
                chunkModules.forEach((moduleId)=>{
                    if (!chunkMapping[id].includes(moduleId)) chunkMapping[id].push(moduleId);
                });
            });
        }
        consumesLoadingData._updated = 1;
    }
    if (initializeSharingData && !initializeSharingData._updated) {
        var federation = webpackRequire.federation;
        if (!federation.instance || !initializeSharingData.scopeToSharingDataMapping) return;
        var shared = {};
        for (var ref of Object.entries(initializeSharingData.scopeToSharingDataMapping)){
            var _ref = _sliced_to_array._(ref, 2), scope = _ref[0], stages = _ref[1];
            for (var stage of stages)if (typeof stage === "object" && stage !== null) {
                var name = stage.name, version = stage.version, factory = stage.factory, eager = stage.eager, singleton = stage.singleton, requiredVersion = stage.requiredVersion, strictVersion = stage.strictVersion;
                var shareConfig = {
                    requiredVersion: `^${version}`
                };
                var isValidValue = function isValidValue(val) {
                    return typeof val !== "undefined";
                };
                if (isValidValue(singleton)) shareConfig.singleton = singleton;
                if (isValidValue(requiredVersion)) shareConfig.requiredVersion = requiredVersion;
                if (isValidValue(eager)) shareConfig.eager = eager;
                if (isValidValue(strictVersion)) shareConfig.strictVersion = strictVersion;
                var _$options = {
                    version,
                    scope: [
                        scope
                    ],
                    shareConfig,
                    get: factory
                };
                if (shared[name]) shared[name].push(_$options);
                else shared[name] = [
                    _$options
                ];
            }
        }
        federation.instance.registerShared(shared);
        initializeSharingData._updated = 1;
    }
}
function updateRemoteOptions(options) {
    var _loop = function(ref) {
        var _ref = _sliced_to_array._(ref, 2), moduleId = _ref[0], data = _ref[1];
        if (!idToExternalAndNameMapping[moduleId]) idToExternalAndNameMapping[moduleId] = [
            data.shareScope,
            data.name,
            data.externalModuleId
        ];
        if (!idToRemoteMap[moduleId] && remoteInfos[data.remoteName]) {
            var items = remoteInfos[data.remoteName];
            idToRemoteMap[moduleId] ||= [];
            items.forEach((item)=>{
                if (!idToRemoteMap[moduleId].includes(item)) idToRemoteMap[moduleId].push(item);
            });
        }
    };
    var _webpackRequire_federation_bundlerRuntimeOptions_remotes, _webpackRequire_federation_bundlerRuntimeOptions, _webpackRequire_federation;
    var webpackRequire = options.webpackRequire, _options_idToExternalAndNameMapping = options.idToExternalAndNameMapping, idToExternalAndNameMapping = _options_idToExternalAndNameMapping === void 0 ? {} : _options_idToExternalAndNameMapping, _options_idToRemoteMap = options.idToRemoteMap, idToRemoteMap = _options_idToRemoteMap === void 0 ? {} : _options_idToRemoteMap, _options_chunkMapping = options.chunkMapping, chunkMapping = _options_chunkMapping === void 0 ? {} : _options_chunkMapping;
    var remotesLoadingData = webpackRequire.remotesLoadingData;
    var remoteInfos = (_webpackRequire_federation = webpackRequire.federation) === null || _webpackRequire_federation === void 0 ? void 0 : (_webpackRequire_federation_bundlerRuntimeOptions = _webpackRequire_federation.bundlerRuntimeOptions) === null || _webpackRequire_federation_bundlerRuntimeOptions === void 0 ? void 0 : (_webpackRequire_federation_bundlerRuntimeOptions_remotes = _webpackRequire_federation_bundlerRuntimeOptions.remotes) === null || _webpackRequire_federation_bundlerRuntimeOptions_remotes === void 0 ? void 0 : _webpackRequire_federation_bundlerRuntimeOptions_remotes.remoteInfos;
    if (!remotesLoadingData || remotesLoadingData._updated || !remoteInfos) return;
    var updatedChunkMapping = remotesLoadingData.chunkMapping, moduleIdToRemoteDataMapping = remotesLoadingData.moduleIdToRemoteDataMapping;
    if (!updatedChunkMapping || !moduleIdToRemoteDataMapping) return;
    for (var ref of Object.entries(moduleIdToRemoteDataMapping))_loop(ref);
    if (chunkMapping) Object.entries(updatedChunkMapping).forEach((param)=>{
        var _param = _sliced_to_array._(param, 2), id = _param[0], chunkModules = _param[1];
        if (!chunkMapping[id]) chunkMapping[id] = [];
        chunkModules.forEach((moduleId)=>{
            if (!chunkMapping[id].includes(moduleId)) chunkMapping[id].push(moduleId);
        });
    });
    remotesLoadingData._updated = 1;
}
//#endregion
exports.updateConsumeOptions = updateConsumeOptions;
exports.updateRemoteOptions = updateRemoteOptions; //# sourceMappingURL=updateOptions.cjs.map
